function initVideoBlocks() {
    let videoBlocks = document.querySelectorAll(".js-blockVideo");

    if (videoBlocks.length === 0) {
        return;
    }



    videoBlocks.forEach((videoBlock) => {

        function handleClick() {
            let videoElem = videoBlock.querySelector('video');
            let playElem = videoBlock.querySelector('.js-play');
            let posterElem = videoBlock.querySelector('.js-poster')

            if (videoElem && playElem) {
                //console.log("i am clicked")
                videoElem.style.minHeight = videoElem.offsetHeight + "px";
                videoElem.setAttribute('controls', '');
                videoElem.load();
                videoElem.play();
                playElem.classList.add('hidden');
                posterElem.classList.add('hidden');
            }
        }
        videoBlock.addEventListener('click', handleClick, { "once": true });
    });
}

export { initVideoBlocks };